import React, { useEffect, useState } from "react";
import useLoggedStatus from "../../hooks/useLoggedStatus";
import EditComponants from "./EditComponants";
import { translation } from "../../translation";
import { useSelector } from "react-redux";
import IdentificationForm from "../Modal/IdentificationForm";
import {
  useAutoFillAiMutation,
  usePostCreateIdentifMutation,
} from "../../redux/appSlices/collaborator/collaboratorApiSlice";
import {
  useGenerateWalletPassMutation,
  useGenerateGoogleWalletPassMutation,
} from "../../redux/appSlices/generalApiSlice";
import { addCollaboratorToWallet } from "../../utils/wallet";
import ContactLock from "./ContactLock";
import useTracking from "../../hooks/useTracking";
import useCollaboratorRestriction from "../../hooks/useCollaboratorRestriction";
import AutoFillPopup from "../Modal/AutoFillPopup";

const AddToContactButton = () => {
  const lang = useSelector(
    (state) => state.collaborator.collaboratorInfo.language,
  );
  const collaborator = useSelector(
    (state) => state.collaborator.collaboratorInfo,
  );

  const logged = useLoggedStatus();
  const restriction = useCollaboratorRestriction();
  const [postCreateIdentif] = usePostCreateIdentifMutation();
  const [AutoFillAi] = useAutoFillAiMutation();
  const [generateWalletPass] = useGenerateWalletPassMutation();
  const [generateGoogleWalletPass] = useGenerateGoogleWalletPassMutation();
  const { sendTracking } = useTracking();

  const [fetchGetVcard, setFetchGetVcard] = useState(false);
  const [openIdentification, setOpenIdentification] = useState(false);
  const [openEditPopup, setOpenEditPopup] = useState(false);
  const [componantToEditId, setComponantToEditId] = useState(0);
  const [dataRes, setDataRes] = useState("");
  const [openFormContactLock, setOpenFormContactLock] = useState(false);

  const [showAuthFillPopup, setShowAuthFillPopup] = useState(false);

  const [contactAccess, setContactAccess] = useState(false);

  const [isScanning, setIsScanning] = useState(false);
  const [userSharedInfo, setUserSharedInfo] = useState({
    email: "",
    first_name: "",
    last_name: "",
    phone: "",
    company: "",
    card: "",
  });

  const [fetchWalletPass, setFetchWalletPass] = useState(false);

  const handleAddToWallet = async () => {
    setFetchWalletPass(true);

    try {
      const walletType = await addCollaboratorToWallet({
        collaboratorId: collaborator._id,
        generateAppleWalletPass: generateWalletPass,
        generateGoogleWalletPass,
      });

      sendTracking({
        action: 66,
        collaborator_id: collaborator.collaborator_id,
        componant:
          walletType === "google" ? "GoogleWalletButton" : "AppleWalletButton",
      });
    } catch (error) {
      console.error("Error generating wallet pass:", error);
    } finally {
      setTimeout(() => {
        setFetchWalletPass(false);
      }, 2000);
    }
  };

  useEffect(() => {
    setContactAccess(!collaborator.contact_locked);
  }, [collaborator.contact_locked]);

  useEffect(() => {
    if (fetchGetVcard) {
      const timeoutId = setTimeout(() => {
        setFetchGetVcard(false);
      }, 2000);

      return () => clearTimeout(timeoutId);
    }
  }, [fetchGetVcard]);

  const handleDownload = () => {
    if (contactAccess) {
      const csvDataUri = `${process.env.REACT_APP_API_BASE_URL}/vcards/${collaborator._id}`;

      sendTracking({
        action: 65,
        collaborator_id: collaborator.collaborator_id,
        componant: "MainButton",
      });
      setTimeout(() => {
        window.open(csvDataUri, "_self");
      }, 2000);
    } else {
      setOpenFormContactLock(true);
    }
  };

  const handleIdentify = () => {
    postCreateIdentif({
      card: "",
      email: "",
      first_name: "",
      last_name: "",
      phone: "",
      company: "",
      identified_in: collaborator?._id,
      tracking: localStorage.getItem("tracking"),
      identification_methode: 0,
      user_token: localStorage.getItem("user_token"),
    })
      .unwrap()
      .then((res) => {
        localStorage.setItem("completerId", res.data.identification._id);
        setDataRes(res.data.identification);
        setOpenIdentification(true);
      })
      .catch((err) => {
        console.log(err);
        setDataRes(err.data);
        localStorage.setItem("completerId", err?.data?._id);
        setOpenIdentification(true);
      });
  };

  const uploadImage = async (file) => {
    setShowAuthFillPopup(false);
    setOpenIdentification(true);

    setIsScanning(true);

    AutoFillAi(file)
      .then((result) => {
        setUserSharedInfo({
          email: result?.data?.data?.email,
          first_name: result?.data?.data?.firstName,
          last_name: result?.data?.data?.lastName,
          phone: (() => {
            let phone = result?.data?.data?.phone?.number || "";
            // Remove spaces, dashes, and dots — keep only digits
            phone = phone.replace(/[\s\-.]/g, "").replace(/\D/g, "");
            return phone;
          })(),
          function: result?.data?.data?.function,
          company: result?.data?.data?.companyName,
          card: result?.data?.data?.filename,
          prefix: (() => {
            let prefix = result?.data?.data?.phone?.prefix || "";
            prefix = prefix.trim().replace(/\s+/g, "");
            if (prefix && !prefix.startsWith("+")) {
              prefix = `+${prefix}`;
            }
            return prefix;
          })(),
        });

        setIsScanning(false);
      })
      .catch((error) => {
        console.error(error);
        setShowAuthFillPopup(true);
        setOpenIdentification(false);
        setIsScanning(false);
      });
  };

  return (
    <>
      <div className="mt-5">
        {logged ? (
          <div className="flex justify-between items-center gap-[10px]">
            {/* <button
              className="h-[50px] w-[11.5rem] text-white bg-black rounded-md text-[13px]"
              style={
                collaborator?.branding?.color
                  ? { backgroundColor: `${collaborator.branding.color}` }
                  : {}
              }
              onClick={() => {
                setOpenEditPopup(true);
                setComponantToEditId(10);
              }}
            >
              <span className="inline-block max-w-[100px]">
                {translation?.mainButton?.showSettings?.[lang]}
              </span>
            </button>
            <button
              className="h-[50px] w-[11.5rem] text-white bg-black rounded-md text-[13px]"
              onClick={() => {
                setOpenEditPopup(true);
                setComponantToEditId(9);
              }}
            >
              <span className="inline-block max-w-[110px]">
                {translation?.mainButton?.updateMyContact?.[lang]}
              </span>
            </button> */}
          </div>
        ) : collaborator.form ? (
          <>
            <div className="flex justify-between items-center gap-[10px]">
              <button
                className="h-[50px] w-[11.5rem] text-white bg-black rounded-md text-[13px] flex items-center justify-center gap-3"
                style={
                  collaborator?.branding?.color
                    ? { backgroundColor: `${collaborator.branding.color}` }
                    : {}
                }
                onClick={() => {
                  setFetchGetVcard(true);
                  handleDownload();
                }}
              >
                <span className="inline-block max-w-[100px]">
                  {!fetchGetVcard ? (
                    translation?.mainButton?.addContact?.[lang]
                  ) : (
                    <img
                      src="/assets/img/loaders/loading.gif"
                      alt="loading Vcard"
                      className="w-[23px] h-[23px]"
                    />
                  )}
                </span>
              </button>
              <button
                className="h-[50px] w-[11.5rem] text-white bg-black rounded-md text-[13px]"
                style={
                  collaborator?.branding?.color
                    ? { backgroundColor: `${collaborator.branding.color}` }
                    : {}
                }
                onClick={handleIdentify}
              >
                <span className="inline-block max-w-[100px]">
                  {translation?.mainButton?.identifyContact?.[lang]}
                </span>
              </button>
            </div>
            {/* <div className="flex justify-center mt-3">
              <button
                className="h-[50px] w-full text-white bg-black rounded-md text-[13px] flex items-center justify-center gap-2"
                style={
                  collaborator?.branding?.color
                    ? { backgroundColor: `${collaborator.branding.color}` }
                    : {}
                }
                onClick={handleAddToWallet}
              >
                {!fetchWalletPass ? (
                  <>
                    <img
                      src="/assets/img/icons/wallet-icon.svg"
                      alt="wallet"
                      className="w-5 h-5"
                    />
                    <span className="inline-block">
                      {translation?.mainButton?.addToWallet?.[lang]}
                    </span>
                  </>
                ) : (
                  <img
                    src="/assets/img/loaders/loading.gif"
                    alt="loading"
                    className="w-[23px] h-[23px]"
                  />
                )}
              </button>
            </div> */}
          </>
        ) : (
          <>
            <button
              className="h-[50px] w-full bg-black rounded-md text-white text-base flex items-center justify-center gap-3"
              style={
                collaborator?.branding?.color
                  ? { backgroundColor: `${collaborator.branding.color}` }
                  : {}
              }
              onClick={() => {
                setFetchGetVcard(true);
                handleDownload();
              }}
            >
              <span className="inline-block w-full">
                {!fetchGetVcard ? (
                  translation?.mainButton?.addContact?.[lang]
                ) : (
                  <img
                    src="/assets/img/loaders/loading.gif"
                    alt="loading Vcard"
                    className="w-[23px] h-[23px]"
                  />
                )}
              </span>
            </button>
            {collaborator?.popcardEcard && (
              <button
                className="h-[50px] w-full bg-black rounded-md text-white text-base flex items-center justify-center gap-2 mt-3"
                style={
                  collaborator?.branding?.color
                    ? { backgroundColor: `${collaborator.branding.color}` }
                    : {}
                }
                onClick={handleAddToWallet}
              >
                {!fetchWalletPass ? (
                  <>
                    <img
                      src="/assets/img/icons/wallet-icon.svg"
                      alt="wallet"
                      className="w-5 h-5"
                    />
                    <span className="inline-block">
                      {translation?.mainButton?.addToWallet?.[lang]}
                    </span>
                  </>
                ) : (
                  <img
                    src="/assets/img/loaders/loading.gif"
                    alt="loading"
                    className="w-[23px] h-[23px]"
                  />
                )}
              </button>
            )}
          </>
        )}
      </div>
      {logged && openEditPopup && (
        <EditComponants
          componantId={componantToEditId}
          setOpenEditPopup={setOpenEditPopup}
        />
      )}

      {openIdentification && collaborator.form && (
        <>
          <IdentificationForm
            close={setOpenIdentification}
            handleShowAuthFillPopup={() => {
              setShowAuthFillPopup(true);
              setOpenIdentification(false);
            }}
            dataRes={dataRes}
            userSharedInfo={userSharedInfo}
            setUserSharedInfo={setUserSharedInfo}
            isScanning={isScanning}
            show={true}
          />
        </>
      )}

      {showAuthFillPopup && collaborator.form && (
        <AutoFillPopup
          showPopup={showAuthFillPopup}
          setShowPopup={setShowAuthFillPopup}
          lang={lang}
          setOpenIdentification={setOpenIdentification}
          upload={uploadImage}
        />
      )}

      {openFormContactLock && (
        <ContactLock
          id={collaborator._id}
          setOpenFormContactLock={setOpenFormContactLock}
          contactAccess={contactAccess}
          setContactAccess={setContactAccess}
          handleDownload={handleDownload}
        />
      )}
    </>
  );
};

export default AddToContactButton;
